export default {
    CONTENT_REGEN: '/content/regen/invoke'
}